import React, { useEffect } from 'react'

import { hooks, I18n } from '@front/volcanion'
import { Loader } from '@front/squirtle'
import { HookUtils } from '@front/volcanion/utils'


function getNextButtonLabel(isOrderStarted, next_transport_status) {
  if (!isOrderStarted)
    return I18n.t(`transport.start_transport`)
  else if (!!next_transport_status)
    return I18n.t(`transportStatus.${next_transport_status}.user`)
  return null
}

const withContainer = Component => props => {
  const { queueJob, total_delay } = props
  const [, { closeDialog }] = hooks.useDialogs()
  const [order_id] = hooks.useFormState('order_id')
  const [closeDialogOnComplete] = hooks.useFormState('closeDialogOnComplete')

  const [order, status] = hooks.useModel('order', [order_id], {
    single: true,
    populate: ['assigned_transport', 'loads']
  })

  const job_id = order?.job
  const assigned_transport = order?.assigned_transport
  const transport_status = assigned_transport?.status
  const [next_transport_status] = hooks.useJobNextStatus({ job_id })

  const isOrderStarted = !_.includes(['planned', 'complete', 'canceled'], transport_status)
  const isOrderCompleted = _.includes(['complete', 'canceled'], transport_status)
  const isPayment = transport_status === 'off_board'
  const isRedispatchActive = !!queueJob
  const isRedispatchPossible = total_delay > 0

  const nextButtonLabel = getNextButtonLabel(isOrderStarted, next_transport_status)
  const transportStatus = hooks.useTransportStatus(assigned_transport, { translated: true, load_type: 'user' })
  const transportStatusColor = hooks.useTransportStatusColor(assigned_transport)
  const orderStatus = hooks.useOrderStatus(order, { translated: true })
  const orderStatusColor = hooks.useOrderStatusColor(order)


  useEffect(() => {
    if (!!closeDialogOnComplete && !!isOrderCompleted)
      closeDialog('simulator')
  }, [transport_status])

  const mergedProps = {
    transportStatus,
    transportStatusColor,
    orderStatus,
    orderStatusColor,
    nextButtonLabel,
    isOrderStarted,
    isOrderCompleted,
    isPayment,
    isRedispatchActive,
    isRedispatchPossible
  }

  return (
    <Loader isLoading={HookUtils.getLoadingState([status])}>
      <Component {...mergedProps} />
    </Loader>
  )
}

export default withContainer
